$(document).on("turbolinks:load", function() {
  if ( document.querySelector('body.companies.index') ) {
    $('form[id^=edit_user_]').change(function() {
      Rails.fire(this.form, 'submit');
    });
  }

  if ( document.querySelector('body.companies.users') ) {
    // Save the "Add to New Sites" setting as soon as it's toggled
    $('form.auto-add-to-sites-form input[type=checkbox]').change(function() {
      this.form.requestSubmit();
    });
  }
});
